<template>

  <div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div :class="['small-box', selectedGroup.group && selectedGroup.group.color !== null ? selectedGroup.group.color : defaultGColor]">
          <div class="inner">
            <div class="row">
              <h3>
                <div class="col-sm-10">
                  <span v-if="selectedGroup.empty">{{$t('pages.adminpanel.group.createGroupPrompt')}}</span>
                  <span v-else-if="selectedGroup.group">{{$t('pages.adminpanel.group.groupPrompt')}}: {{selectedGroup.group.name | pickTranslation}}</span>
                </div>
                <div class="btn-group col-sm-2">
                  <div class="pull-right">
                    <button v-if="!selectedGroup.empty" type="button" class="btn btn-default" @click.prevent="colapseEditGroup(2)">
                    <i class="fa fa-edit"></i>
                    </button>
                  </div>
                </div>
              </h3>
            </div>
            <br>
            <div class="row">
              <h3>
                <div class="col-sm-10">
                  <b v-if="!selectedYear.empty">{{$t('pages.adminpanel.year.yearPrompt')}}: {{selectedYear.name}}</b>
                  <b v-else>{{$t('pages.adminpanel.year.createYear')}}</b>
                </div>
                <div class="btn-group col-sm-2" v-if="!selectedGroup.empty">
                  <div class="pull-right">
                    <button v-if="!selectedYear.empty" type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                    <span class="fa fa-arrow-down"></span>
                    <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul class="dropdown-menu" role="menu">
                      <li v-for="gj in groupYears">
                        <a @click.prevent="updateYear(gj)">{{gj.name}}</a>
                      </li>
                    </ul>
                    <button type="button" v-if="!selectedYear.empty" class="btn btn-default" @click.prevent="colapseEditYear(4)">
                    <i class="fa fa-edit"></i>
                    </button>
                    <button type="button" class="btn btn-default" @click.prevent="colapseCreateYear(3)">
                    <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
              </h3>
            </div>
            <!--<p>{{selectedGroup.group.description}}</p>-->
          </div>
          <div v-if="!colEG" class="small-box-footer">
            <editgroup :group="selectedGroup.group"></editgroup>
          </div>
          <div v-if="!colCY" class="small-box-footer"  style="text-align: unset">
            <createyear :gid="gid"></createyear>
          </div>
          <div v-if="!colEY" class="small-box-footer"  style="text-align: unset">
            <edityear :year="selectedYear"></edityear>
          </div>
        </div>
      </div>
      <span v-if="!selectedYear.empty && selectedGroup.group">
        <div class="col-xs-12" :class="[ratingStatistics ? 'col-md-4' : 'col-md-6', ratingStatistics ? 'col-sm-4' : 'col-sm-6']">
          <router-link :to="{ name: 'exercises', params: {gid: selectedGroup.group.id.toString(), yid: selectedYear.id.toString(), sid: 'root'}}" class="small-box-footer">
            <div :class="['small-box', selectedGroup.group && selectedGroup.group.color !== null ? selectedGroup.group.color : defaultGColor]">
              <div class="inner">
                <h3>{{$t('pages.adminpanel.exercises.bannerName')}}</h3>
                <p>{{$t('pages.adminpanel.exercises.manageExercisesButton')}}</p>
              </div>
              <div class="icon">
                <i class="fa fa-inbox"></i>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-xs-12" :class="[ratingStatistics ? 'col-md-4' : 'col-md-6', ratingStatistics ? 'col-sm-4' : 'col-sm-6']">
          <router-link :to="{ name: 'classes', params: {gid: selectedGroup.group.id.toString(), yid: selectedYear.id.toString()}}" class="small-box-footer">
            <div class="small-box bg-red">
              <div class="inner">
                <h3>{{$t('pages.adminpanel.classes.bannerName')}}</h3>
                <p>{{$t('pages.adminpanel.classes.manageClassesButton')}}</p>
              </div>
              <div class="icon">
                <i class="fa fa-users"></i>
              </div>
            </div>
          </router-link>
        </div>

        <div class="col-md-4 col-sm-4 col-xs-12 clickable" v-if="ratingStatistics">
          <div data-toggle="modal" data-target="#modal-userRatings" class="small-box-footer">
            <div class="small-box bg-blue">
              <div class="inner">
                <h3>{{$t('pages.adminpanel.ratingStatistics.bannerName')}}</h3>
                <p>{{$t('pages.adminpanel.ratingStatistics.studentRatings')}}</p>
              </div>
              <div class="icon">
                <i class="fa fa-line-chart"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4 col-sm-6 col-xs-12">
          <router-link :to="{ name: 'tablets'}" class="small-box-footer">
            <div class="small-box bg-aqua">
              <div class="inner">
                <h3>{{$t('pages.adminpanel.tablets.bannerName')}}</h3>
                <p>{{$t('pages.adminpanel.tablets.manageExamsButton')}}</p>
              </div>
              <div class="icon">
                <i class="fa fa-tablet"></i>
              </div>
            </div>
          </router-link>
        </div> -->
        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="info-box">
            <span :class="['info-box-icon', selectedGroup.group && selectedGroup.group.color !== null ? selectedGroup.group.color : defaultGColor]">
            <i class="fa fa-inbox"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">{{$t('pages.adminpanel.subgroup.nmOfSubgroupsPrompt')}}</span>
              <span class="info-box-number">{{selectedGroup.subgroups.length}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="info-box">
            <span class="info-box-icon bg-yellow">
            <i class="fa fa-clock-o"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">{{$t('pages.adminpanel.tablets.nmOfExamsPrompt')}}</span>
              <span class="info-box-number">{{selectedGroup.exams.length}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="info-box">
            <span class="info-box-icon bg-red">
            <i class="fa fa-users"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">{{$t('pages.adminpanel.users.nmOfUsersPrompt')}}</span>
              <span class="info-box-number">{{userCount}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>

        <!--rating statistics-->
        <div class="col-md-4 col-sm-6 col-xs-12" v-if="ratingStatistics">
          <div class="info-box">
            <span :class="['info-box-icon', selectedGroup.group && selectedGroup.group.color !== null ? selectedGroup.group.color : defaultGColor]">
            <i class="fa fa-line-chart"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text" style="white-space: pre-wrap">{{$t('pages.adminpanel.ratingStatistics.ratingExamsInLastWeek')}}</span>
              <span class="info-box-number">{{ratingStatistics.ratingExamsLastWeek}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12" v-if="ratingStatistics">
          <div class="info-box">
            <span :class="['info-box-icon', selectedGroup.group && selectedGroup.group.color !== null ? selectedGroup.group.color : defaultGColor]">
            <i v-if="ratingStatistics.averageChangeOfRatingInTheLastWeek >= 0" class="fa fa-chevron-up"></i>
            <i v-else class="fa fa-chevron-down"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text" style="white-space: pre-wrap">{{$t('pages.adminpanel.ratingStatistics.averageRatingChange')}}</span>
              <span class="info-box-number">{{ratingStatistics.averageChangeOfRatingInTheLastWeek}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12 clickable" @click="openModalForSelectiongClass()" v-if="ratingStatistics">
          <div class="info-box">
            <span :class="['info-box-icon', selectedGroup.group && selectedGroup.group.color !== null ? selectedGroup.group.color : defaultGColor]">
            <i class="fa fa-download"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text" style="white-space: pre-wrap">{{$t('pages.adminpanel.ratingStatistics.exportUserRatingsCSV')}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </div>

        <div class="col-xs-12">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">{{$t('pages.adminpanel.statistics.group')}}</h3>
            </div>
            <!-- /.box-header -->
            <div class="box-body">
              <div class="margin">
                <div class="">
                  <div class="form-group">
                    <label class="control-label col-sm-2">{{$t('pages.adminpanel.createdailychallenge.dateRange')}}:</label>
                    <div class="col-sm-10">
                      <date-range-picker v-model="dateRange" nameOfPicker="customNameStatistics"></date-range-picker>
                    </div>
                  </div>
                  <br><br><br>
                  <div class="col-sm-12">
                    <line-chart class="" :height="125" :chartData="{labels: timeAxis, datasets: [{label: $t('pages.adminpanel.statistics.registered'), backgroundColor: '#687979', data: registerChartY}]}"></line-chart>
                    <!-- TODO TRANSLATE -->
                  </div>
                  <div class="col-sm-12">
                    <line-chart class="" :height="125" :chartData="{labels: timeAxis, datasets: [{label: $t('pages.adminpanel.statistics.active'), backgroundColor: '#112345', data: activeChartY}]}"></line-chart>
                    <!-- TODO TRANSLATE -->
                  </div>
                  <div class="col-sm-12">
                    <bar class="" :height="125" :chartData="{labels: timeAxis, datasets: [{label: $t('pages.adminpanel.statistics.exC'), backgroundColor: '#f87979', data: statcorrectY}, {label: $t('pages.adminpanel.statistics.ecW'), backgroundColor: '#112345', data: statWrongY}]}" :options="{scales: {xAxes: [{stacked: true, barPercentage: '1',  categoryPercentage: '0.9'}], yAxes: [{stacked: true}]}}"></bar>
                  </div>
                  <div class="col-sm-3">
                  </div>
                </div>
                <div class="col-sm-6">
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>

        <div class="col-xs-12" v-if="ratingStatistics">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">{{$t('pages.adminpanel.ratingStatistics.group')}}</h3>
            </div>
            <!-- /.box-header -->
            <div class="box-body">
              <div class="margin">
                <div class="">
                  <h5>{{$t('pages.adminpanel.ratingStatistics.userRatings')}}</h5>
                  <div class="row">
                    <div class="col-sm-12">
                      <bar style="height: 20em" class="" :height="125" :chartData="{labels: ratingHistogramX, datasets: [{label: $t('pages.adminpanel.ratingStatistics.numberOfStudents'), backgroundColor: '#2872ca', data: ratingHistogramY}]}" :options="{maintainAspectRatio: false, responsive: true, scales: {xAxes: [{stacked: true, barPercentage: '1',  categoryPercentage: '0.9'}], yAxes: [{stacked: true}]}}"></bar>
                    </div>
                  </div>

                  <h5>{{$t('pages.adminpanel.ratingStatistics.exerciseRatings')}}</h5>
                  <div class="row">
                    <div class="col-sm-12">
                      <bar style="height: 20em" class="" :height="125" :chartData="{labels: ratingHistogramXExercise, datasets: [{label: $t('pages.adminpanel.ratingStatistics.numberOfExercises'), backgroundColor: '#2872ca', data: ratingHistogramYExercise}]}" :options="{maintainAspectRatio: false, responsive: true, scales: {xAxes: [{stacked: true, barPercentage: '1.0',  categoryPercentage: '0.9'}], yAxes: [{stacked: true}]}}"></bar>
                    </div>
                  </div>

                  <div class="col-sm-3">
                  </div>
                </div>

                <div class="col-sm-6">
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>
      </span>
    </div>

    <div class="modal modal-default fade" id="modal-selectClass">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.adminpanel.ratingStatistics.exportUserRatingsCSV')}}</h4>
          </div>
          <div class="modal-body">
            <div class="col-xs-12 clickable" @click="downloadUserRating(-1)">
              <div class="info-box">
                <span :class="['info-box-icon', selectedGroup.group && selectedGroup.group.color !== null ? selectedGroup.group.color : defaultGColor]">
                  <i class="fa fa-users"></i>
                </span>
                <div class="info-box-content">
                  <span class="info-box-text" style="white-space: pre-wrap">{{$t('pages.adminpanel.ratingStatistics.downloadAllUsers')}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            </div>
            <h4>{{$t('pages.adminpanel.ratingStatistics.downloadSingleClass')}}</h4>
            <table class="table">
              <tbody>
              <tr>
                <th style="width: 3em">#</th>
                <th>{{$t('pages.adminpanel.ratingStatistics.name')}}</th>
                <th></th>
              </tr>
              <tr v-for="(c, i) in classes" class="clickable" @click="downloadUserRating(c.id)">
                <td>{{i + 1}}.</td>
                <td>{{c.name}}</td>
                <td><i class="fa fa-download pull-right"></i></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal modal-default fade" id="modal-userRatings">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.adminpanel.ratingStatistics.userRatingStatistics')}}</h4>
          </div>
          <div class="modal-body">
            <table class="table">
              <tbody v-if="ratingStatistics && ratingStatistics.individualUserStatistics">
              <tr>
                <th class="hidden-xs" style="width: 3em">#</th>
                <th>{{$t('pages.adminpanel.ratingStatistics.name')}}</th>
                <th class="hidden-xs">{{$t('pages.adminpanel.ratingStatistics.studentId')}}</th>
                <th>{{$t('pages.adminpanel.ratingStatistics.numberOfRatingTests')}}</th>
                <th>{{$t('pages.adminpanel.ratingStatistics.currentRating')}}</th>
                <th></th>
              </tr>
              <tr v-for="(user, i) in ratingStatistics.individualUserStatistics">
                <td class="hidden-xs">{{i + 1}}.</td>
                <td>{{user.name}}</td>
                <td class="hidden-xs">{{user.studentId}}</td>
                <td>{{user.numberOfRatingTests}}</td>
                <td v-if="user.allowUseOfMyResults">{{user.currentRating}}</td>
                <td v-else><i class="fa fa-eye-slash"></i></td>
                <td>
                  <a v-if="user.allowUseOfMyResults" class="clickable" @click.stop.prevent="showUserRatingStatistics(user.userId)">{{$t('pages.adminpanel.ratingStatistics.showMore')}}</a>
                  <span v-else>{{$t('pages.adminpanel.ratingStatistics.hiddenStatistics')}}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>

</template>

<script>
import Rest from './../../../services/rest'
import editgroup from './../../admin/group/EditGroupPanel'
import { saveAs } from 'file-saver/FileSaver'
// import creategroup from './../admin/CreateGroup'
import router from '@/router/router'
import createyear from './../../admin/group/CreateYearPanel'
import edityear from './../../admin/group/EditYearPanel'
import { mapState, mapGetters } from 'vuex'
import Bar from '@/charts/Bar.js'
import Line from '@/charts/Line.js'
import Radar from '@/charts/Radar.js'
import DateRangePicker from '@/components/reusables/DateRangePicker.vue'
let moment = require('moment')
export default {
  data () {
    return {
      userCount: '',
      registerChartX: [],
      registerChartY: [],
      activeChartX: [],
      activeChartY: [],
      statcorrectY: [],
      statWrongY: [],
      timeAxis: [],
      dateRange: null,
      ratingStatistics: null,
      ratingHistogramX: [],
      ratingHistogramY: [],
      ratingHistogramXExercise: [],
      ratingHistogramYExercise: [],
      classes: []
    }
  },
  watch: {
    dateRange (value) { // Action on apply picker
      this.filterStatistics(value)
    },
    '$route' (to, from) {
      console.log('dr')
      this.prepareComponent() // react to route changes... due to same component
    }
  },
  /*
  beforeRouteUpdate (to, from, next) {
    console.log('happened')
    console.log(to)
    console.log(from)
    console.log(next)
    console.log({name: 'admin', params: {gid: this.gid, yid: this.yid}})
    next({name: 'admin', params: {gid: this.gid, yid: to.params.yid}})
  },
  */
  props: ['gid', 'yid'],
  methods: {
    downloadUserRating (classId) {
      return Rest.requestForm('GET', '/rating/groups/' + this.gid + '/classes/' + classId + '/userRatingExport').then((data) => {
        if (!data.message) {
          var blob = new Blob([data], {type: 'text/csv;charset=utf-8'})
          saveAs(blob, 'student_rating.csv')
        } else {
          Rest.Vue.$snotify.error(this.$t('alerts.results'), this.errorThrown)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    openModalForSelectiongClass () {
      Rest.requestForm('GET', '/years/' + this.yid + '/classes/').then((data) => {
        this.classes = data.classes
      }).catch((err) => {
        console.log(err)
      })
      window.jQuery('#modal-selectClass').modal('toggle')
    },
    ratingToHistogramGroup (rating) {
      let spodnjaMeja = Math.floor(rating / 10) * 10
      return spodnjaMeja + '-' + (spodnjaMeja + 9)
    },
    getRatingStatistics () {
      return Rest.request('GET', `/rating/statistics/` + this.gid).then((data) => {
        this.ratingStatistics = data
        this.ratingHistogramX = []
        this.ratingHistogramY = []
        this.ratingHistogramXExercise = []
        this.ratingHistogramYExercise = []
        let spodnjaMeja = 300
        let zgornjaMeja = 100

        for (let ratingBorder = 100; ratingBorder < 300; ratingBorder += 10) {
          let imeSkupine = this.ratingToHistogramGroup(ratingBorder)
          if (data.userRatingHistogram[imeSkupine] !== undefined || data.exerciseRatingHistogram[imeSkupine] !== undefined) {
            if (ratingBorder < spodnjaMeja) {
              spodnjaMeja = ratingBorder
            }
            if (ratingBorder > zgornjaMeja) {
              zgornjaMeja = ratingBorder
            }
          }
        }

        let padding = Math.max((100 - (zgornjaMeja - spodnjaMeja)) / 2, 10)

        for (let ratingBorder = Math.round((spodnjaMeja - padding) / 10) * 10; ratingBorder <= zgornjaMeja + padding; ratingBorder += 10) {
          let imeSkupine = this.ratingToHistogramGroup(ratingBorder)
          this.ratingHistogramX.push(imeSkupine)
          this.ratingHistogramXExercise.push(imeSkupine)
          if (data.userRatingHistogram[imeSkupine] !== undefined) {
            this.ratingHistogramY.push(data.userRatingHistogram[imeSkupine])
          } else {
            this.ratingHistogramY.push(0)
          }
          if (data.exerciseRatingHistogram[imeSkupine] !== undefined) {
            this.ratingHistogramYExercise.push(data.exerciseRatingHistogram[imeSkupine])
          } else {
            this.ratingHistogramYExercise.push(0)
          }
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    filterStatistics (data) {
      let postdata = {
        startDate: data.start,
        endDate: data.end,
        fields: ['registerCount', 'activeCount', 'correctCount', 'wrongCount']
      }
      this.$store.dispatch('getGlobalStatistics', postdata).then(() => {
        this.prepareGlobalStat()
      })
    },
    getGroup () {
      let selectedGroup = {}
      selectedGroup.years = []
      selectedGroup.group = this.groupList.find((el) => {
        return el.id === parseInt(this.gid)
      })
      this.$store.commit('updateSelectedGroup', selectedGroup)
    },
    updateData (groupYear) {
      // this.$store.commit('updateSelectedGroup', groupName) // update group selecetion
      this.$store.commit('updateSelectedYear', groupYear) // update group selecetion
      router.push({name: 'admin', params: {gid: this.gid, yid: groupYear.id, sid: 'root'}})
    },
    showUserRatingStatistics (userId) {
      window.jQuery('#modal-userRatings').modal('hide')
      router.push({name: 'UserRatingByIdAdmin', params: {gid: this.gid, yid: this.yid, uid: userId}})
    },
    getUsers: function () {
      return Rest.request('GET', '/statistics/year/' + this.selectedYear.id + '/enrolledUsers').then((data) => {
        this.userCount = data
      }).catch((err) => {
        console.log(err)
      })
    },
    /*
    updateGroup (fullGroup) {
      this.updateData(fullGroup)
      this.isAnthingAlreadyColapsed()
    },
    */
    updateYear (fullYear) {
      this.updateData(fullYear)
      this.isAnthingAlreadyColapsed()
    },
    colapseEditGroup (meSelf) {
      this.isAnthingAlreadyColapsed(meSelf)
      this.$store.commit('toggleEditGroup')
    },
    colapseCreateYear (meSelf) {
      this.isAnthingAlreadyColapsed(meSelf)
      this.$store.commit('toggleCreateYear')
    },
    colapseEditYear (meSelf) {
      this.isAnthingAlreadyColapsed(meSelf)
      this.$store.commit('toggleEditYear')
    },
    isAnthingAlreadyColapsed (meSelf) {
      if (!this.colEG && meSelf !== 2) {
        this.$store.commit('toggleEditGroup')
      } else if (!this.colCY && meSelf !== 3) {
        this.$store.commit('toggleCreateYear')
      } else if (!this.colEY && meSelf !== 4) {
        this.$store.commit('toggleEditYear')
      }
    },
    prepareGlobalStat () {
      this.timeAxis = this.getGlobalStatistics.map((el) => el.date)
      // this.timeAxis = this.timeAxis.filter(function (value, index, Arr) {
      //   return index % 3 === 0
      // })
      this.timeAxis.forEach(function (part, index, theArray) {
        theArray[index] = moment(part).format('MM/DD/YYYY')
      })
      this.registerChartY = this.getGlobalStatistics.map((el) => el.registerCount) // y os
      // this.registerChartY = this.registerChartY.filter(function (value, index, Arr) {
      //   return index % 3 === 0
      // })
      this.activeChartY = this.getGlobalStatistics.map((el) => el.activeCount) // y os
      this.statcorrectY = this.getGlobalStatistics.map((el) => el.correctCount)
      this.statWrongY = this.getGlobalStatistics.map((el) => el.wrongCount)
    },
    prepareComponent () {
      this.$store.dispatch('getGroup', {
        gid: this.gid,
        yid: this.yid,
        sid: 'root'
      }).then(() => {
        this.getUsers()
        this.$store.dispatch('getGlobalStatistics').then(() => {
          this.prepareGlobalStat()
        })
      }).catch((err) => {
        console.log(err)
        this.getGroup()
      })
      this.$store.commit('updateAdminBreadcrumbs', [{path: 'admin', name: {'en-us': 'Control Panel', sl: 'Nadzorna plošča'}}])
    }
  },
  mounted () {
    this.prepareComponent()
    this.getRatingStatistics()
  },
  components: {
    editgroup: editgroup,
    // creategroup: creategroup,
    createyear: createyear,
    edityear: edityear,
    bar: Bar,
    'line-chart': Line,
    'radar-chart': Radar,
    'date-range-picker': DateRangePicker
  },
  computed: {
    ...mapState({
      colEG: state => state.adminpanel.colapseEditGroup,
      colCY: state => state.adminpanel.colapseCreateYear,
      colEY: state => state.adminpanel.colapseEditYear,
      defaultGColor: state => state.defaultGColor,
      selectedGroup: state => state.selectedGroup,
      groupYears: state => state.selectedGroup.years,
      selectedYear: state => state.selectedYear,
      groupList: state => state.groupList,
      getGlobalStatistics: state => state.statistics.global
    }),
    ...mapGetters({
      seznamPodskupin: 'getSubgroups'
    })
  }
}

</script>

<style scoped>
.statChart {
  height: 100px;
}
.clickable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// AdminPanel.vue?edacb5c6